module.exports = __webpack_public_path__ + "static/media/ng02.fabb1271.webp";